export default __webpack_public_path__ + "static/media/nonPremiumAnalytics.968f929d.jpg";